import { Box, useMediaQuery, useTheme } from '@mui/material';
import React, { useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { routeName } from '../../routes/routeName';
import Hashids from 'hashids';
import { BANNER_TYPE } from '../../pages/cms-website/website-structure/content/enum/content.enum';
import clsx from 'clsx';
import PreviewImage from '../preview-image/PreviewImage';
import { ImageContent } from '../../assets/background/background';

type Props = {
    banner_slide: any[];
    mode?: 'ACTIVITY';
    disabled_link?: boolean;
    banner_type: string;
    onClick?: () => void;
}
export enum BANNER_GROUP {
    HOME = "HOME",
    ADMISSION = "ADMISSION",
    NEWS = "NEWS",
    ACTIVITY = "ACTIVITY"
}

const chunkArray = (array: any[], size: number) => {
    return Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
        array.slice(index * size, index * size + size)
    );
};

const BannerSlide: React.FC<Props> = ({ banner_slide, mode, disabled_link, banner_type }: Props) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));
    const baseApi = useSelector((state: RootState) => state.api.image_api);
    const navigate = useNavigate();
    const sliderRef = useRef<any>(null);

    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);
    const media_file = banner_slide;

    const chunks: any[] = chunkArray(banner_slide?.length > 0 ? banner_slide : [], 4);

    return (
        <div>


            {chunks?.length !== 0 && banner_type !== BANNER_TYPE.TYPE_THREE && (
                <>
                    <section className="w-full h-full">
                        <div
                            className={clsx(
                                "grid grid-cols-12 gap-4 h-full lg:h-fit overflow-hidden",
                                {
                                    hidden:
                                        banner_type === BANNER_TYPE.TYPE_FOUR ||
                                        banner_type === BANNER_TYPE.TYPE_THREE ||
                                        banner_type === BANNER_TYPE.TYPE_TWO,
                                }
                            )}
                        >
                            <Box
                                component={"span"}
                                data-aos="fade-right"
                                data-aos-offset="0"
                                data-aos-easing="ease-in-sine"
                                data-aos-anchor-placement="top-bottom"
                                className={clsx(
                                    "h-full max-h-[500px] shadow-md rounded-2xl overflow-hidden",
                                    {
                                        "col-span-12 md:col-span-12 lg:col-span-6":
                                            banner_type === BANNER_TYPE.TYPE_TWO,
                                        // 'col-span-12 md:col-span-12 lg:col-span-8': banner_type === BANNER_TYPE.TYPE_THREE,
                                        "col-span-12 max-h-full": banner_type === BANNER_TYPE.TYPE_ONE,
                                    }
                                )}
                            >
                                {banner_type !== BANNER_TYPE.TYPE_ONE && (
                                    <>
                                        {media_file?.length > 0 ? (
                                            <PreviewImage
                                                disable_show={false}
                                                disabled_max_width
                                                image_url={`${baseApi}/${media_file[0]?.media_file_path}${media_file[0]?.media_file_name}`}
                                                render_image={
                                                    <img
                                                        className="w-full h-full object-cover"
                                                        src={`${baseApi}/${media_file[0]?.media_file_path}${media_file[0]?.media_file_name}`}
                                                        alt="image"
                                                    />
                                                }
                                            />
                                        ) : (
                                            <img
                                                className="w-full h-full object-cover"
                                                src={ImageContent.noImage}
                                                alt="noImage"
                                            />
                                        )}
                                    </>
                                )}
                                {banner_type === BANNER_TYPE.TYPE_ONE &&
                                    media_file?.length > 0 ? (
                                    <Box component="article" sx={{ width: '100%' }}>
                                        {banner_slide?.length > 0 && (
                                            <Swiper
                                                navigation={{
                                                    enabled: true,
                                                }}
                                                ref={sliderRef}
                                                modules={[Navigation, Pagination, Autoplay]}
                                                pagination={{ clickable: true }}
                                                breakpoints={{
                                                    320: { slidesPerView: 1, spaceBetween: 0 },
                                                    768: { slidesPerView: 1, spaceBetween: 0 },
                                                    1024: { slidesPerView: 1, spaceBetween: 0 },
                                                }}
                                                autoplay={{
                                                    delay: 2500,
                                                    waitForTransition: true,
                                                    pauseOnMouseEnter: true,
                                                }}
                                                className="news_slider"
                                                style={{ width: '100%', height: matches ? "20em" : "628px" }}
                                            >
                                                {banner_slide?.map((list, i) => {
                                                    const id = hash_ids.encode(String(list?.banner_link || "").trim());
                                                    const imgSrc = `${baseApi}/${list?.media_file_path}${list?.media_file_name}`;
                                                    return (
                                                        <SwiperSlide key={`${list?.id_content}_${i}`}>
                                                            <Box
                                                                onClick={() => {
                                                                    const banner_link = String(list?.banner_link || "");
                                                                    if (disabled_link) return;
                                                                    if (!banner_link.startsWith("CT")) {
                                                                        if (list?.banner_status_open === 'current_tab') {
                                                                            return window.location.href = list?.banner_link;
                                                                        } else {
                                                                            return window.open(list?.banner_link, '_blank');
                                                                        }
                                                                    }
                                                                    const path_name = list?.banner_link ?
                                                                        `${mode === 'ACTIVITY' ? routeName.main.activityDetail.replace(":id", id) :
                                                                            routeName.main.contentDetail.replace(":content_no", list?.banner_link)
                                                                        }`
                                                                        : ""
                                                                    if (list?.banner_status_open === 'current_tab') {
                                                                        navigate(path_name)
                                                                    } else {
                                                                        window.open(path_name, "_blank")
                                                                    }
                                                                }}
                                                                sx={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    position: 'relative',
                                                                    cursor: 'pointer',
                                                                    overflow: 'hidden',
                                                                    backgroundColor: 'white',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                }}
                                                            >
                                                                <img
                                                                    src={imgSrc}
                                                                    alt="blur background"
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        objectFit: 'cover',
                                                                        filter: 'blur(20px)',
                                                                        opacity: 0.3,
                                                                        zIndex: 0,
                                                                        position: 'absolute',
                                                                        top: 0,
                                                                        left: 0,
                                                                    }}
                                                                />

                                                                <img
                                                                    src={imgSrc}
                                                                    alt="content"
                                                                    style={{
                                                                        maxWidth: '100%',
                                                                        maxHeight: '100%',
                                                                        objectFit: 'contain',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                            </Box>
                                                        </SwiperSlide>
                                                    );
                                                })}
                                            </Swiper>
                                        )}
                                    </Box>
                                ) : (
                                    <img
                                        className="w-full h-full object-cover"
                                        src={ImageContent.noImage}
                                        alt="noImage"
                                    />
                                )}
                            </Box>
                            <Box
                                component={"span"}
                                data-aos="fade-right"
                                data-aos-offset="0"
                                data-aos-anchor-placement="top-bottom"
                                data-aos-easing="ease-in-sine"
                                className={clsx(
                                    "h-full max-h-[500px] rounded-2xl overflow-hidden",
                                    {
                                        "col-span-12 md:col-span-12 lg:col-span-3 ":
                                            banner_type === BANNER_TYPE.TYPE_TWO,
                                        hidden:
                                            banner_type === BANNER_TYPE.TYPE_THREE ||
                                            banner_type === BANNER_TYPE.TYPE_ONE,
                                    }
                                )}
                            >
                                {media_file?.length > 1 ? (
                                    <PreviewImage
                                        disable_show={false}
                                        disabled_max_width
                                        image_url={`${baseApi}/${media_file[1]?.media_file_path}${media_file[1]?.media_file_name}`}
                                        render_image={
                                            <img
                                                className="w-full h-full object-cover"
                                                src={`${baseApi}/${media_file[1]?.media_file_path}${media_file[1]?.media_file_name}`}
                                                alt="image"
                                            />
                                        }
                                    />
                                ) : (
                                    <img
                                        className="w-full h-full object-cover"
                                        src={ImageContent.noImage}
                                        alt="noImage"
                                    />
                                )}
                            </Box>
                            <Box
                                component={"span"}
                                data-aos="fade-down"
                                data-aos-easing="linear"
                                data-aos-offset="0"
                                data-aos-anchor-placement="top-bottom"
                                data-aos-duration="600"
                                className={clsx(
                                    "h-full  max-h-[500px] flex flex-row lg:flex-col ",
                                    {
                                        "col-span-12 gap-4 md:col-span-12 lg:col-span-3":
                                            banner_type === BANNER_TYPE.TYPE_TWO,
                                        "col-span-12 gap-4 md:col-span-12 lg:col-span-4":
                                            banner_type === BANNER_TYPE.TYPE_THREE,
                                        hidden: banner_type === BANNER_TYPE.TYPE_ONE,
                                    }
                                )}
                            >
                                <div
                                    className={clsx(
                                        "w-full h-full rounded-2xl overflow-hidden",
                                        {}
                                    )}
                                >
                                    {media_file?.length > 2 ? (
                                        <PreviewImage
                                            disable_show={false}
                                            disabled_max_width
                                            image_url={`${baseApi}/${media_file[2]?.media_file_path}${media_file[2]?.media_file_name}`}
                                            render_image={
                                                <img
                                                    className="w-full h-full object-cover"
                                                    src={`${baseApi}/${media_file[2]?.media_file_path}${media_file[2]?.media_file_name}`}
                                                    alt="image"
                                                />
                                            }
                                        />
                                    ) : (
                                        <img
                                            className={clsx("w-full h-full object-cover")}
                                            src={ImageContent.noImage}
                                            alt="noImage"
                                        />
                                    )}
                                </div>
                                <div className="w-full h-full rounded-2xl overflow-hidden">
                                    {media_file?.length > 3 ? (
                                        <PreviewImage
                                            disable_show={false}
                                            disabled_max_width
                                            image_url={`${baseApi}/${media_file[3]?.media_file_path}${media_file[3]?.media_file_name}`}
                                            render_image={<img
                                                className="w-full h-full object-cover"
                                                src={`${baseApi}/${media_file[3]?.media_file_path}${media_file[3]?.media_file_name}`}
                                                alt="image"
                                            />}
                                        />
                                    ) : (
                                        <img
                                            className="w-full h-full object-cover"
                                            src={ImageContent.noImage}
                                            alt="noImage"
                                        />
                                    )}
                                </div>
                            </Box>
                        </div>
                    </section>

                    {/* TYPE 2 AND 3 */}
                    <section className="w-full h-full">
                        <Swiper
                            spaceBetween={30}
                            pagination={{
                                clickable: true,
                            }}
                            modules={[Pagination]}
                            className="type_one"
                            autoplay={{
                                delay: 1000,
                            }}
                        >
                            {chunks?.length > 0 &&
                                chunks?.map((chunk: any, main_index) => {
                                    return (
                                        <SwiperSlide key={main_index}>
                                            <div
                                                className={clsx(
                                                    "grid grid-cols-12 gap-4 h-full lg:h-fit overflow-hidden",
                                                    {
                                                        hidden: !(
                                                            banner_type === BANNER_TYPE.TYPE_TWO ||
                                                            banner_type === BANNER_TYPE.TYPE_THREE
                                                        ),
                                                    }
                                                )}
                                            >
                                                <React.Fragment>
                                                    <Box
                                                        component={"span"}
                                                        data-aos="fade-right"
                                                        data-aos-offset="จ" /* i18n-ignore */
                                                        data-aos-easing="ease-in-sine"
                                                        data-aos-anchor-placement="top-bottom"
                                                        className={clsx(
                                                            "h-full max-h-[500px] shadow-md rounded-2xl overflow-hidden",
                                                            {
                                                                "col-span-12 md:col-span-12 lg:col-span-6":
                                                                    banner_type === BANNER_TYPE.TYPE_TWO,
                                                                "col-span-12 md:col-span-12 lg:col-span-8":
                                                                    banner_type === BANNER_TYPE.TYPE_THREE,
                                                            }
                                                        )}
                                                    >
                                                        {chunk[0]?.media_file_path ? (
                                                            <PreviewImage
                                                                disable_show={false}
                                                                disabled_max_width
                                                                image_url={`${baseApi}/${chunk[0]?.media_file_path}${chunk[0]?.media_file_name}`}
                                                                render_image={<img
                                                                    className="w-full h-full object-cover"
                                                                    src={`${baseApi}/${chunk[0]?.media_file_path}${chunk[0]?.media_file_name}`}
                                                                    alt="image"
                                                                />}
                                                            />
                                                        ) : (
                                                            <img
                                                                className="w-full h-full object-cover"
                                                                src={ImageContent.noImage}
                                                                alt="noImage"
                                                            />
                                                        )}
                                                    </Box>
                                                    <Box
                                                        component={"span"}
                                                        data-aos="fade-right"
                                                        data-aos-offset="จ" /* i18n-ignore */
                                                        data-aos-anchor-placement="top-bottom"
                                                        data-aos-easing="ease-in-sine"
                                                        className={clsx(
                                                            "h-full max-h-[500px] rounded-2xl overflow-hidden",
                                                            {
                                                                "col-span-12 md:col-span-12 lg:col-span-3 ":
                                                                    banner_type === BANNER_TYPE.TYPE_TWO,
                                                                hidden:
                                                                    banner_type === BANNER_TYPE.TYPE_THREE,
                                                            }
                                                        )}
                                                    >
                                                        {chunk[1]?.media_file_path ? (
                                                            <PreviewImage
                                                                disable_show={false}
                                                                disabled_max_width
                                                                image_url={`${baseApi}/${chunk[1]?.media_file_path}${chunk[1]?.media_file_name}`}
                                                                render_image={
                                                                    <img
                                                                        className="w-full h-full object-cover"
                                                                        src={`${baseApi}/${chunk[1]?.media_file_path}${chunk[1]?.media_file_name}`}
                                                                        alt="image"
                                                                    />
                                                                }
                                                            />
                                                        ) : (
                                                            <img
                                                                className="w-full h-full object-cover"
                                                                src={ImageContent.noImage}
                                                                alt="noImage"
                                                            />
                                                        )}
                                                    </Box>
                                                    <Box
                                                        component={"span"}
                                                        data-aos="fade-down"
                                                        data-aos-easing="linear"
                                                        data-aos-offset="0"
                                                        data-aos-anchor-placement="top-bottom"
                                                        data-aos-duration="600"
                                                        className={clsx(
                                                            "h-full  max-h-[500px] flex flex-row lg:flex-col ",
                                                            {
                                                                "col-span-12 gap-4 md:col-span-12 lg:col-span-3":
                                                                    banner_type === BANNER_TYPE.TYPE_TWO,
                                                                "col-span-12 gap-4 md:col-span-12 lg:col-span-4":
                                                                    banner_type === BANNER_TYPE.TYPE_THREE,
                                                                hidden:
                                                                    banner_type === BANNER_TYPE.TYPE_ONE ||
                                                                    banner_type === BANNER_TYPE.TYPE_THREE,
                                                            }
                                                        )}
                                                    >
                                                        <div
                                                            className={clsx(
                                                                "w-full h-full rounded-2xl overflow-hidden",
                                                                {}
                                                            )}
                                                        >
                                                            {chunk[2]?.media_file_path ? (
                                                                <PreviewImage
                                                                    disable_show={false}
                                                                    disabled_max_width
                                                                    image_url={`${baseApi}/${chunk[2]?.media_file_path}${chunk[2]?.media_file_name}`}
                                                                    render_image={
                                                                        <img
                                                                            className="w-full h-full object-cover"
                                                                            src={`${baseApi}/${chunk[2]?.media_file_path}${chunk[2]?.media_file_name}`}
                                                                            alt="image"
                                                                        />
                                                                    }
                                                                />
                                                            ) : (
                                                                <img
                                                                    className={clsx(
                                                                        "w-full h-full object-cover"
                                                                    )}
                                                                    src={ImageContent.noImage}
                                                                    alt="noImage"
                                                                />
                                                            )}
                                                        </div>
                                                        <div className="w-full h-full rounded-2xl overflow-hidden">
                                                            {chunk[3]?.media_file_path ? (
                                                                <PreviewImage
                                                                    disable_show={false}
                                                                    disabled_max_width
                                                                    image_url={`${baseApi}/${chunk[3]?.media_file_path}${chunk[3]?.media_file_name}`}
                                                                    render_image={
                                                                        <img
                                                                            className="w-full h-full object-cover"
                                                                            src={`${baseApi}/${chunk[3]?.media_file_path}${chunk[3]?.media_file_name}`}
                                                                            alt="image"
                                                                        />
                                                                    }
                                                                />
                                                            ) : (
                                                                <img
                                                                    className="w-full h-full object-cover"
                                                                    src={ImageContent.noImage}
                                                                    alt="noImage"
                                                                />
                                                            )}
                                                        </div>
                                                    </Box>
                                                </React.Fragment>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                        </Swiper>
                    </section>
                </>
            )}
        </div >
    )
}

export default BannerSlide;
